define("settings/components/profiles/user-name", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--formWrapper">
    <label>{{t "account.social_accounts.username.header"}}</label>
    <p class="o--form__helpText">
      {{t "account.social_accounts.username.sub_header"}}
    </p>
    <Input @type="text" @value={{@username}} />
  </div>
  <div class="o--btnBar u--float--right">
    <Shared::Ui::Button
      @promise={{@updateProfileNickname}}
      @text={{t "shared_words.save"}}
      @variant="primary"
      data-test-id="username-save-button"
    />
  </div>
  */
  {
    "id": "phKHPjRi",
    "block": "[[[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n  \"],[10,\"label\"],[12],[1,[28,[35,0],[\"account.social_accounts.username.header\"],null]],[13],[1,\"\\n  \"],[10,2],[14,0,\"o--form__helpText\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"account.social_accounts.username.sub_header\"],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[8,[39,1],null,[[\"@type\",\"@value\"],[\"text\",[30,1]]],null],[1,\"\\n\"],[13],[1,\"\\n\"],[10,0],[14,0,\"o--btnBar u--float--right\"],[12],[1,\"\\n  \"],[8,[39,2],[[24,\"data-test-id\",\"username-save-button\"]],[[\"@promise\",\"@text\",\"@variant\"],[[30,2],[28,[37,0],[\"shared_words.save\"],null],\"primary\"]],null],[1,\"\\n\"],[13]],[\"@username\",\"@updateProfileNickname\"],false,[\"t\",\"input\",\"shared/ui/button\"]]",
    "moduleName": "settings/components/profiles/user-name.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});